import { Model, modelRegistry } from './Model';
import { Client, DispatchItem } from '.';
import Printable from '../print/Printable';
import { documentHeader, documentLines, documentSignatures, documentTable, factLine } from '../print/DocumentLayout';
import Store from '../wrappers/Store';
import { I18n } from '../wrappers/I18n';
import moment from 'moment-timezone';
export class Dispatch extends Model {
    static entity = 'dispatches';
    id = null;
    number = null;
    warehouse_id = null;
    date = null;
    client_id = null;
    storekeeper = null;
    comment = null;
    created_at = null;
    updated_at = null;
    items = [];
    client;
    dispatch_type = null;
    register_type = null;
    counterparty_id = null;
    counterparty;
    warehouse = null;
    /** Inventory accounting: the GoodsIssue attached to an internal dispatch (list rows). */
    goods_issue = null;
    static fields() {
        return {
            id: this.attr(null),
            number: this.attr(null),
            warehouse_id: this.attr(null),
            date: this.attr(null),
            client_id: this.attr(null),
            storekeeper: this.attr(null),
            comment: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            items: this.attr([], (value) => (value || []).map(item => new DispatchItem(item))),
            client: this.attr(undefined, value => value ? new Client(value) : undefined),
            dispatch_type: this.attr(null),
            register_type: this.attr(null),
            counterparty_id: this.attr(null),
            counterparty: this.attr(undefined),
            warehouse: this.attr(null, (value) => value ? { id: Number(value.id), name: String(value.name) } : null),
            goods_issue: this.attr(null, (value) => value ? { id: Number(value.id), number: String(value.number), recorded_at: value.recorded_at ?? null } : null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    /** Legacy internal transfer to another venue of the same company (not a CRF e-dispatch). */
    isInternal() {
        return this.dispatch_type === 'int' && !this.register_type;
    }
    getPrintable() {
        const pr = new Printable();
        const venue = Store.get('tenant')?.venue;
        if (!venue)
            return pr;
        documentHeader(pr, {
            title: I18n.t('general.dispatch'),
            facts: factLine([I18n.t('general.number'), this.number], [I18n.t('general.date'), moment(this.date).format('DD.MM.YYYY.')]),
            venueName: venue.name,
            venueLine: `${I18n.t('general.tax_id_number')}: ${venue.tax_id_number}`,
        });
        documentLines(pr, [
            factLine([I18n.t('general.buyer'), this.counterparty?.name || this.client?.name]),
            factLine([I18n.t('dispatches.dispatched_by'), this.storekeeper]),
            factLine([I18n.t('general.comment'), this.comment]),
        ]);
        const columns = [
            { label: I18n.t('general.number'), kind: 'index' },
            { label: I18n.t('general.code'), kind: 'code' },
            { label: I18n.t('general.inventory_item'), kind: 'name' },
            { label: I18n.t('general.quantity'), kind: 'figure' },
        ];
        const rows = this.items.map((item, index) => [
            String(index + 1),
            item.getProduct()?.code || '',
            item.getProduct()?.name || '',
            `${item.getCount()} ${item.getProduct()?.getUnitOfMeasureSold() || item.getProduct()?.getUnitOfMeasure() || ''}`,
        ]);
        documentTable(pr, columns, rows, { density: 'regular' });
        documentSignatures(pr, [I18n.t('general.received_by')]);
        return pr;
    }
}
export default Dispatch;
modelRegistry.register('Dispatch', Dispatch);
//# sourceMappingURL=Dispatch.js.map